import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from "reactstrap";
import { withRouter, Redirect } from "react-router";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AgGridReact, reactCellRendererFactory } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import {
  getSeasonalitySchemas,
  deleteSeasonalitySchemas,
  updateSeasonalitySchemas,
  addSeasonalitySchemas
} from "../../../store/actions";
import actionRenderer from "./actionRenderer";
import Modal from "./Modal";
import { func } from "prop-types";

let isEditable = true;
class Tables extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showmodal: false,
      hello: "",
      warning: "",

      columnDefs: [
        {
          headerName: "Select",
          // field: "select",
          editable: isEditable,
          checkboxSelection: true,
          width: 35
        },
        {
          headerName: "Name",
          field: "name",
          editable: isEditable,
          width: 100
        },
        {
          headerName: "Jan",
          field: "january",
          editable: isEditable,
          type: "valueColumn",
          width: 90
        },
        {
          headerName: "Feb",
          field: "february",
          type: "valueColumn",
          editable: isEditable,
          width: 90
        },
        {
          headerName: "Mar",
          type: "valueColumn",
          field: "march",
          editable: true,
          width: 90
        },
        {
          headerName: "Apr",
          field: "april",
          editable: true,
          width: 90,
          type: "valueColumn"
        },
        {
          headerName: "May",
          field: "may",
          editable: true,
          width: 90,
          type: "valueColumn"
        },
        {
          headerName: "Jun",
          field: "june",
          editable: true,
          width: 90,
          type: "valueColumn"
        },
        {
          headerName: "Jul",
          field: "july",
          editable: true,
          width: 90,
          type: "valueColumn"
        },
        {
          headerName: "Aug",
          field: "august",
          editable: true,
          width: 90,
          type: "valueColumn"
        },
        {
          headerName: "Sep",
          field: "september",
          editable: true,
          width: 90,
          type: "valueColumn"
        },
        {
          headerName: "Oct",
          field: "october",
          editable: true,
          width: 90,
          type: "valueColumn"
        },
        {
          headerName: "Nov",
          field: "november",
          editable: true,
          width: 90,
          type: "valueColumn"
        },
        {
          headerName: "Dec",
          field: "december",
          editable: true,
          width: 90,
          type: "totalColumn",
          valueGetter:
            '100 - (+getValue("january") + +getValue("february") + +getValue("march")+  +getValue("april")+ +getValue("may")+ +getValue("june") + +getValue("july")+ +getValue("august")+ +getValue("october")+ +getValue("september")+ +getValue("november"))'
        },
        { headerName: "Total", field: "total", width: 100 },
        { headerName: "Creation Date", field: "created_at", width: 100 },
        {
          headerName: "Api version created with",
          field: "version",
          width: 100
        },
        {
          headerName: "Action",
          field: "action",
          width: 150,
          cellRenderer: "deleteRenderer",
          cellRendererParams: {
            onDelete: () => this.onRemoveSelected(),
            onEdit: () => this.updateItems()
          }
        }
      ],
      columnTypes: {
        valueColumn: {
          editable: true,
          aggFunc: "sum",
          // valueParser: "Number(newValue)",
          cellClass: "number-cell",
          cellRenderer: "agAnimateShowChangeCellRenderer",
          filter: "agNumberColumnFilter"
        },
        totalColumn: {
          cellRenderer: "agAnimateShowChangeCellRenderer",
          cellClass: "number-cell"
        }
      },
      editType: "fullRow",
      context: { componentParent: this },

      frameworkComponents: {
        deleteRenderer: function(params) {
          let buttons = "";

          buttons = (
            <div>
              <i
                className="btn-delete fa fa-trash fa-lg "
                onClick={params.onDelete}
              />
              |
              {params.data.id ? (
                <i
                  className="btn-edit fa fa-pencil fa-lg"
                  onClick={params.onEdit}
                />
              ) : (
                <i className="btn-add fa fa-check-circle" onClick={params.onEdit} />
              )}
            </div>
          );
          return buttons;
        }
      },
      rowData: []
    };
    this.onGridReady = this.onGridReady.bind(this);
  }

  toggle = () => {
    this.setState({
      showmodal: false
    });
  };
  onBtForEachNode() {
    this.gridApi.forEachNode(this.printNode);
  }

  getRowData = () => {
    var rowData = [];

    this.gridApi.forEachNode(function(node) {
      rowData.push(node.data);
    });
  };
  clearData() {
    this.gridApi.setRowData([]);
  }
  onAddRow() {
    var rowData = [];
    let obj = {};
    this.gridApi.forEachNode(function(node) {
      obj = {
        april: null,
        august: null,
        december: 100,
        february: null,
        january: null,
        july: null,
        june: null,
        march: null,
        may: null,
        november: null,
        october: null,
        september: null
      };
      rowData.push(node.data);
    });

    this.setState({ rowData: [...this.state.rowData, obj] });
    var res = this.gridApi.updateRowData({ add: [rowData] });
  }

  async updateItems() {
    var itemsToUpdate = [];
    let total = [];
    var selectedData = this.gridApi.getSelectedRows();

    if (selectedData.length > 0) {
      this.gridApi.forEachNode(function(rowNode, index) {
        var data = rowNode.data;
        let month = [];
        for (let elem in data) {
          if (
            elem !== "id" &&
            elem !== "total" &&
            elem !== "name" &&
            elem !== "created_at" &&
            elem !== "version" &&
            elem !== "action" &&
            elem !== "user" &&
            elem !== "december"
          ) {
            month.push(+data[elem]);
          }
        }
        let sum = month.reduce((acc, cur) => {
          return acc + cur;
        }, 0);
        data.december = 100 - sum;
        if (sum + data.december === 100) {
          data.total = sum + data.december;
        } else {
          data.total = "error";
          total.push("error");
        }
        itemsToUpdate.push(data);
      });
      if (total.length === 0) {
        const data = selectedData[0];
        const updateData = {
          april: +data.april,
          august: +data.august,
          december: +data.december,
          february: +data.february,
          january: +data.january,
          july: +data.july,
          june: +data.june,
          march: +data.march,
          may: +data.may,
          name: data.name,
          november: +data.november,
          october: +data.october,
          september: +data.september
        };

        const res = data.id
          ? await this.props.updateSeasonalitySchemas(updateData, data.id)
          : await this.props.addSeasonalitySchemas(updateData);
        if (res && res.payload.status === 201) {
          let resData = res.payload.data;
          resData.total = 100;
          let UpdateItems = itemsToUpdate.filter(data => {
            return data.id;
          });

          UpdateItems.push(resData);
          this.setState({ rowData: UpdateItems });
          this.gridApi.updateRowData({ update: UpdateItems });
        }
      }
    } else {
      this.setState({ warning: "please select row" });
    }
  }
  onInsertRowAt2() {
    var newItem = createNewRowData();
    var res = this.gridApi.updateRowData({
      add: [newItem],
      addIndex: 2
    });
  }
  async onRemoveSelected() {
    var selectedData = this.gridApi.getSelectedRows();
    if (selectedData.length > 0) {
      const response = await this.props.deleteSeasonalitySchemas(
        selectedData[0].id
      );
      response &&
        response.payload.status === 204 &&
        this.gridApi.updateRowData({ remove: selectedData });
    }

    // printResult(res);
  }

  // onGridReady(params) {="name">{a}</Label>
  //   this.gridApi = params.api;
  //   this.gridColumnApi = params.columnApi;
  //   this.gridApi.forEachNode(node => {
  //     if (node.data.id === 1) {
  //       node.setSelected(true);
  //     }
  //   });
  //   params.api.sizeColumnsToFit();
  // }
  async onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    await this.props.getSeasonalitySchemas();
    const rowData = [];
    this.props.seasonalitySchemas &&
      this.props.seasonalitySchemas.results &&
      this.props.seasonalitySchemas.results.map(data => {
        let obj = {
          april: data.april,
          august: data.august,
          created_at: data.created_at,
          // december: data.december,
          february: data.february,
          id: data.id,
          january: data.january,
          july: data.july,
          june: data.june,
          march: data.march,
          may: data.may,
          name: data.name,
          november: data.november,
          october: data.october,
          september: data.september,
          user: data.user,
          version: data.version,
          total: 100
        };
        rowData.push(obj);
      });

    this.setState({ rowData });
    // this.gridApi.forEachNode(function(node) {
    //   if (node.id === "0") {
    //     node.setSelected(true);
    //   }
    // });

    const updateData = data => {
      this.setState({ rowData: data });
    };
  }
  onSelectionChanged() {
    var selectedRows = this.gridApi.getSelectedRows();
    var selectedRowsString = "";
    selectedRows.forEach(function(selectedRow, index) {
      if (index !== 0) {
        selectedRowsString += ", ";
      }
      selectedRowsString += selectedRow.athlete;
    });
    document.querySelector("#selectedRows").innerHTML = selectedRowsString;
  }
  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              {this.state.warning && (
                <div style={{ color: "red", textAlign: "center" }}>
                  <p>{this.state.warning}</p>
                </div>
              )}

              <CardBody>
                Seasonality
                <div>
                  <Button
                    style={{ float: "right" }}
                    onClick={this.onAddRow.bind(this)}
                    color="primary"
                  >
                    Add New
                  </Button>
                </div>
                <div
                  className="ag-theme-material"
                  style={{
                    height: "400px",
                    width: "100%",
                    marginTop: "50px"
                  }}
                >
                  <AgGridReact
                    enableSorting={true}
                    enableFilter={true}
                    onGridReady={this.onGridReady.bind(this)}
                    columnDefs={this.state.columnDefs}
                    rowData={this.state.rowData}
                    rowSelection="single"
                    context={this.state.context}
                    frameworkComponents={this.state.frameworkComponents}
                    // suppressRowClickSelection={true}
                    // autoGroupColumnDef={this.state.autoGroupColumnDef}
                  />
                </div>
                <div style={{ position: "absolute", top: "0px", left: "0px" }}>
                  <div>
                    <button
                      className="delete"
                      style={{ display: "none" }}
                      onClick={this.onRemoveSelected.bind(this)}
                    >
                      Remove Selected
                    </button>
                  </div>
                  {/* <button onClick={this.onBtForEachNode.bind(this)}>
                    For-Each Node
                  </button> */}
                  <button
                    className="edit"
                    onClick={this.updateItems.bind(this)}
                    style={{ display: "none" }}
                  >
                    Update
                  </button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
  printNode(node, index) {
    if (node.group) {
    } else {
      console.log(
        index + " -> data: " + node.data.country + ", " + node.data.athlete
      );
    }
  }
}

var newCount = 1;
function createNewRowData() {
  var newData = {
    make: "Toyota " + newCount,
    model: "Celica " + newCount,
    price: 35000 + newCount * 17,
    zombies: "Headless",
    style: "Little",
    clothes: "Airbag"
  };
  newCount++;
  return newData;
}
function printResult(res) {
  console.log("---------------------------------------");
  if (res.add) {
    res.add.forEach(function(rowNode) {
      console.log("Added Row Node", rowNode);
    });
  }
  if (res.remove) {
    res.remove.forEach(function(rowNode) {
      console.log("Removed Row Node", rowNode);
    });
  }
  if (res.update) {
    res.update.forEach(function(rowNode) {
      console.log("Updated Row Node", rowNode);
    });
  }
}

const mapStateToProps = state => {
  return {
    seasonalitySchemas: state.seasonalitySchemas
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    {
      getSeasonalitySchemas,
      deleteSeasonalitySchemas,
      updateSeasonalitySchemas,
      addSeasonalitySchemas
    }
  )(Tables)
);



// WEBPACK FOOTER //
// ./src/views/Seasonability/Seasonability/Table.js